import React from 'react';
import { BrowserView } from 'react-device-detect';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Arquivo from 'Interface/Arquivos';
import { useRemoverArquivoMutation } from 'View/Service/Default/Arquivos';

interface Props {
  dados: Arquivo;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerArquivo] = useRemoverArquivoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerArquivo(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <a
          href={dados.url}
          target="_blank"
          className="text-decoration-none"
          rel="noreferrer"
        >
          {dados.nome}
        </a>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.criado.data().toLocaleString()}
          </div>
        </div>
        <div className="ms-2 fs-5 text-end">
          {acoes && (
            <Botao
              icone="trash"
              tema="danger"
              className="ms-5"
              confirmacao="Você tem certeza que deseja remover esse arquivo? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
